import React, { Component } from "react";
import { connect } from "react-redux";
import { encryptPassword } from "../../../../utils/functions";
import { getSpk, getEnvironment } from "../../../../../Redux/reducer/env";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as sessionActions from "../../../../../Redux/actions/sessionActions";
import PropTypes from "prop-types";
import StepControl from "../../register/steps/stepControl";
import Modal from "../../../../utils/customModal";
import { loadingHtml, errorContainer } from "../../../../utils/functions";
import cert from "../../../../utils/cert.json";

import UserIcon from "../../../../../../static/images/user-icon.svg";
import CloseIcon from "../../../../../../static/images/close-icon.svg";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";

/*
  OLD ENDPOINTS
  IST http://10.34.49.70/IB/RecuperacionClave/  
  UAT https://sel-dev.scotiabank.fi.cr/IB/RecuperacionClave/ 
*/

export class ResetStep1 extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      user: {
        codUser: "",
      },
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
      errors: {
        codUser: "",
      },
    };
  }

  handlerChange(event) {
    // Limpiamos los errores
    const { user, errors } = this.state;
    errors[event.target.name] = "";
    user[event.target.name] = event.target.value;

    this.setState({ user, errors });
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
  };

  closeButton(element) {
    return this.state.user[element] != "" ? (
      <div
        key={`clear-${element}`}
        className="button-auto input-w-aux__action clear-user"
        onClick={(event) => this.clear(event, element)}
      >
        <img src={CloseIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  clear(event, element) {
    event.preventDefault();
    const user = this.state.user;
    user[element] = "";

    this.setState({ user });
  }

  submitForm(e) {
    e.preventDefault();
    const { user, errors } = this.state;

    // validamos campos vacios
    if (user.codUser != "") {
      errors.codUser = "";
      this.setState({ errors });

      const { user } = this.state;
      const { modal } = this.state;
      const { validateUser } = this.props.actions;

      modal.show = true;
      this.setState({ modal });

      var redirectUrl = cert.login[this.props.env].forget;

      return validateUser({
        codUser: encryptPassword(user.codUser, this.props.spk),
      })
        .then((response) => {
          var data = response.data.data;

          switch (data.userType) {
            case "PRO":
              if (data.isClientLeap) {
                return (window.location.href = `${
                  cert.login[this.props.env].cams
                }aos/login.bns?spEntityId=REVFACTORING&countryId=RFPA&locale=es&isMultiCountry=false`);
              } else if (data.isClientScotia === false) {
                return this.props.submitStep(true, { codUser: user.codUser });
              } else {
                return (window.location.href = redirectUrl);
              }
            case "CSA":
              if (data.isClientLeap)
                return (window.location.href = `${
                  cert.login[this.props.env].cams
                }aos/login.bns?spEntityId=REVFACTORING&countryId=RFPA&locale=es&isMultiCountry=false`);
              else return (window.location.href = redirectUrl);
          }
          return true;
        })
        .catch((err) => {
          if (
            err.response !== undefined &&
            Array.isArray(err.response.data.notifications)
          ) {
            const notification = err.response.data.notifications[0];
            modal.modalMessage = {
              title: notification.message,
              message: notification.description,
            };
          }
          modal.type = "error";
          this.setState({ modal });
        });
    } else {
      if (user.codUser == "") {
        errors.codUser = "Debe completar este campo";
      }
      this.setState({ errors });
    }
  }

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;
    //modalMessage
    switch (type) {
      case "loading":
        return loadingHtml();
      case "error":
        return errorContainer(modalMessage.title, modalMessage.message, {
          continueBtn: { action: this.closeModal, text: "Aceptar" },
        });
    }
  };

  inputErrors(id, hasFocus = false) {
    document.getElementById(id).classList.add("input--error");
    if (hasFocus) {
      document.getElementById(id).focus();
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { modal } = this.state;
    return (
      <div id="step-1">
        <div className="user-credentials">
          <h1>Verificar usuario</h1>
          <div className="login-form">
            <form
              className="login"
              action="post"
              onSubmit={(e) => this.submitForm(e)}
            >
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={UserIcon}
                  alt={`Usuario`}
                />
                <input
                  id="codUser"
                  name="codUser"
                  type="text"
                  className="input input--text input-w-aux__input input--active"
                  autoComplete="off"
                  placeholder={`Ingrese su usuario`}
                  value={this.state.user.codUser}
                  onChange={(event) => this.handlerChange(event)}
                />
                {this.closeButton("codUser")}
                {this.displayError("codUser")}
              </div>
              <StepControl
                currentStep={1}
                submitStep={(e) => this.submitForm(e)}
              />
            </form>
          </div>
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          hideClose={modal.type == "loading"}
          handleClose={this.closeModal}
        >
          {this.getModalContent()}
        </Modal>
      </div>
    );
  }
}

ResetStep1.propTypes = {
  user: PropTypes.object,
  submitStep: PropTypes.func,
};

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
    env: getEnvironment(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch)(ResetStep1));
